var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDogUpperIncisors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 263.7 118.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:1.5px;}.cls-2{font-size:10px;fill:#4d4d4d;font-family:SegoeUI-Semibold, Segoe UI;font-weight:600;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "incisors"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dog_upper_incisors"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_101",
    "data-name": 101,
    className: "cls-1",
    d: "M124,7.17c-.36-.3-10.39-9.78-22-.28-7.1,5.79-5.56,16.68-4.35,25.3C100.09,50,110.71,71,118.46,69.78c8.52-1.37,9.8-29,10.25-38.76C129.56,12.59,125.58,8.54,124,7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_102",
    "data-name": 102,
    className: "cls-1",
    d: "M84.77,12.15c-8-7-23.46-3.2-29.33,7.56-4.7,8.61-1.73,18.88.69,27.27,4.32,15,15.61,35.53,24.47,33.49,9.81-2.27,12-31.21,10.59-48C90.49,24,89.78,16.55,84.77,12.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_103",
    "data-name": 103,
    className: "cls-1",
    d: "M15.67,107.38c11.35,7.81,43.69-7,45.95-25.06C64.68,57.78,11.53,32.58,3.14,40.55.59,43,3.58,47.09,7.32,65.61,13.21,94.83,9.53,103.15,15.67,107.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_201",
    "data-name": 201,
    className: "cls-1",
    d: "M139.53,7.17c5.8-4.95,16.08-5.14,22-.28,7.1,5.79,5.56,16.68,4.35,25.3C163.41,50,152.79,71,145,69.78c-8.52-1.37-9.8-29-10.25-38.76C133.94,12.59,137.92,8.54,139.53,7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_202",
    "data-name": 202,
    className: "cls-1",
    d: "M178.8,12.15c8-7,23.47-3.2,29.34,7.56,4.69,8.61,1.73,18.88-.69,27.27-4.33,15-15.62,35.53-24.47,33.49-9.81-2.27-12-31.21-10.6-48C173.08,24,173.79,16.55,178.8,12.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_203",
    "data-name": 203,
    className: "cls-1",
    d: "M248,107.38c-11.35,7.81-43.69-7-46-25.06C199,57.78,252.16,32.58,260.55,40.55c2.55,2.41-.44,6.54-4.18,25.06C250.48,94.83,254.16,103.15,248,107.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "numbering"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(50.14 113.9)"
  }, "103"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(75.89 96.09)"
  }, "102"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(111.53 86.12)"
  }, "101"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(138.59 86.12)"
  }, "201"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(171.67 96.21)"
  }, "202"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(196.72 113.78)"
  }, "203"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogUpperIncisors);
export default __webpack_public_path__ + "static/media/dog_upper_incisors.c46ec6f9e8f19edfa3c1e138066edb3d.svg";
export { ForwardRef as ReactComponent };